import { useState } from 'react'

import { Button, DrawerBodyWrapper, DrawerFooterWrapper, Select } from '@base'
import { strings } from '@constants'

const blacklistReasons = [
	{
		name: 'Delay in Dispatch',
	},
	{
		name: 'Delay in Processing Refunds',
	},
	{
		name: 'Not accepting Material Shortage',
	},
	{
		name: 'Back out from SPO',
	},
]

const unblackListReasons = [
	{
		name: 'Issue Resolved',
	},
	{
		name: 'Payment Cleared',
	},
	{
		name: 'Quality Improved',
	},
	{
		name: 'New Agreement Signed',
	},
	{
		name: 'Management Decision',
	},
]

const BlacklistOrg = ({ blacklist, callback }) => {
	const [reason, setReason] = useState()
	const [reasonsList, setReasonsList] = useState(blacklist ? blacklistReasons : unblackListReasons)

	const updateReason = (val) => {
		if (val?.is_new_item) {
			setReasonsList([...reasonsList, val])
		}
		setReason(val)
	}

	const submitHandler = () => {
		callback(reason?.name)
	}

	return (
		<>
			<DrawerBodyWrapper>
				<Select
					id={'reason'}
					label={strings('reason')}
					placeholder={strings(['enter', 'reason'])}
					data={reasonsList}
					primaryKey={'name'}
					displayKey={'name'}
					value={reasonsList?.find((item) => item.name === reason?.name) ?? {}}
					onChange={updateReason}
					createNewOption
				/>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button small disabled={!reason} onClick={submitHandler}>
					{strings('submit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default BlacklistOrg
